// extracted by mini-css-extract-plugin
export var arrows = "_50-5";
export var decrementer = "_50-9";
export var disabled = "_50-3";
export var error = "_50-1";
export var hiddenText = "_50-a";
export var incrementer = "_50-8";
export var input = "_50-7";
export var inputWrapper = "_50-0";
export var leadingIcon = "_50-b";
export var readonly = "_50-2";
export var regular = "_50-6";
export var small = "_50-4";